export const STORAGE_KEYS = {
  TASKS: 'spd_tasks',
  THEME: 'spd_theme',
  SETTINGS: 'spd_settings',
};

export const loadFromStorage = (key, fallback) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : fallback;
  } catch {
    return fallback;
  }
};

export const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

export const clearStorage = (key) => {
  try { localStorage.removeItem(key); } catch {}
};
